import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"

export function useGetAuthenticatedUser() {
  return useSuspenseQueryGet("/api/User/GetAuthenticatedUser", null)
}
